import { setStoredUserId } from "./userSession.js";

/**
 * Apply access flags from API payloads. Persists subscriber + userId locally.
 * @param {object} data
 * @param {Function} setIsSubscriber
 * @param {Function} [setIsPaidSubscriber]
 * @param {Function} [setUserId]
 */
export function applyAccessFromApi(data, setIsSubscriber, setIsPaidSubscriber, setUserId) {
  if (data && typeof data.isSubscriber === "boolean") {
    setIsSubscriber(data.isSubscriber);
    localStorage.setItem("ahavibes_is_subscriber", data.isSubscriber ? "true" : "false");
  }
  if (data && typeof data.isPaidSubscriber === "boolean" && typeof setIsPaidSubscriber === "function") {
    setIsPaidSubscriber(data.isPaidSubscriber);
  }
  if (data?.userId) {
    setStoredUserId(data.userId);
    if (typeof setUserId === "function") setUserId(data.userId);
  }
}
